/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import {
  AppSchemasTransactionCountListTransactionCountMeta,
  AppSchemasTransactionCountListTransactionCountMeta$inboundSchema,
  AppSchemasTransactionCountListTransactionCountMeta$Outbound,
  AppSchemasTransactionCountListTransactionCountMeta$outboundSchema,
} from "./appschemastransactioncountlisttransactioncountmeta.js";
import {
  AppSchemasTransactionCountTransactionCountMetric,
  AppSchemasTransactionCountTransactionCountMetric$inboundSchema,
  AppSchemasTransactionCountTransactionCountMetric$Outbound,
  AppSchemasTransactionCountTransactionCountMetric$outboundSchema,
} from "./appschemastransactioncounttransactioncountmetric.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasTransactionCountListTransactionCountResponse = {
  data: Array<AppSchemasTransactionCountTransactionCountMetric>;
  meta: AppSchemasTransactionCountListTransactionCountMeta;
};

/** @internal */
export const AppSchemasTransactionCountListTransactionCountResponse$inboundSchema:
  z.ZodType<
    AppSchemasTransactionCountListTransactionCountResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    data: z.array(
      AppSchemasTransactionCountTransactionCountMetric$inboundSchema,
    ),
    meta: AppSchemasTransactionCountListTransactionCountMeta$inboundSchema,
  });

/** @internal */
export type AppSchemasTransactionCountListTransactionCountResponse$Outbound = {
  data: Array<AppSchemasTransactionCountTransactionCountMetric$Outbound>;
  meta: AppSchemasTransactionCountListTransactionCountMeta$Outbound;
};

/** @internal */
export const AppSchemasTransactionCountListTransactionCountResponse$outboundSchema:
  z.ZodType<
    AppSchemasTransactionCountListTransactionCountResponse$Outbound,
    z.ZodTypeDef,
    AppSchemasTransactionCountListTransactionCountResponse
  > = z.object({
    data: z.array(
      AppSchemasTransactionCountTransactionCountMetric$outboundSchema,
    ),
    meta: AppSchemasTransactionCountListTransactionCountMeta$outboundSchema,
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasTransactionCountListTransactionCountResponse$ {
  /** @deprecated use `AppSchemasTransactionCountListTransactionCountResponse$inboundSchema` instead. */
  export const inboundSchema =
    AppSchemasTransactionCountListTransactionCountResponse$inboundSchema;
  /** @deprecated use `AppSchemasTransactionCountListTransactionCountResponse$outboundSchema` instead. */
  export const outboundSchema =
    AppSchemasTransactionCountListTransactionCountResponse$outboundSchema;
  /** @deprecated use `AppSchemasTransactionCountListTransactionCountResponse$Outbound` instead. */
  export type Outbound =
    AppSchemasTransactionCountListTransactionCountResponse$Outbound;
}

export function appSchemasTransactionCountListTransactionCountResponseToJSON(
  appSchemasTransactionCountListTransactionCountResponse:
    AppSchemasTransactionCountListTransactionCountResponse,
): string {
  return JSON.stringify(
    AppSchemasTransactionCountListTransactionCountResponse$outboundSchema.parse(
      appSchemasTransactionCountListTransactionCountResponse,
    ),
  );
}

export function appSchemasTransactionCountListTransactionCountResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  AppSchemasTransactionCountListTransactionCountResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AppSchemasTransactionCountListTransactionCountResponse$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'AppSchemasTransactionCountListTransactionCountResponse' from JSON`,
  );
}
